module.exports = __webpack_public_path__ + "assets/img/9.3ce006ae.png";